import AudioAndTranscriptBlock from '@dyl/blocks/AudioAndTranscriptBlock';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import useTaskField from './useTaskField';

const useStyles = makeStyles(theme => ({
    header: {
        marginBottom: theme.spacing(2),
    },
}));

export default function TaskEndAudio() {
    const classes = useStyles();

    const [id, setId, error] = useTaskField('final_audio_id');

    return (
        <>
            <Typography variant='h6' className={classes.header}>
                End Audio
            </Typography>

            <AudioAndTranscriptBlock
                id='final-end-audio'
                label='End Audio'
                value={id}
                onChange={id => setId(id)}
                error={error}
                allowEmpty
            />
        </>
    );
}